module.exports = __webpack_public_path__ + "static/media/10_perspectives-burnaby.b5c18c44.jpg";